import { useEffect } from 'react';

export function useGrabbingCursor(active: boolean) {
  useEffect(() => {
    if (!active) return undefined;
    document.body.classList.add('grabbing-cursor');
    return () => {
      document.body.classList.remove('grabbing-cursor');
    };
  }, [active]);
}
